import { Component, OnInit, Input } from '@angular/core';

import { Modelo } from "../shared/modelo.model";
import { ModeloNavigationService } from "../shared/modelo-navigation.service";
import { UtilService } from "../../../shared/services/util.service";
import { ModeloApiService } from "../shared/modelo-api.service";
import { modelosModuleName } from "../shared/data.service";
import { ModeloService } from "../shared/modelo.service";
import { Marca } from "../../marcas/shared/marca.model";

@Component({
  selector: 'app-modelo-list',
  template: require('./modelo-list.component.html'),
  styles: [require('./modelo-list.component.css')]
})
export class ModeloListComponent implements OnInit {
  @Input() list: Modelo[] = [];
  @Input() marcaObject: Marca = new Marca();
  @Input() showDisabled: boolean = true;

  modeloModule: any = modelosModuleName;

  private formaControleList: any[];

  constructor(
    private _modeloNavigationService: ModeloNavigationService,
    private _modelosApiService: ModeloApiService,
    private _modeloservice: ModeloService,
    private _utilService: UtilService
  ) { }

  ngOnInit() {

  }

  clickNew() {
    this._modeloservice.setSessionStorageFatherModule(this.marcaObject);
    this._modeloNavigationService.goToNew();
  }

  clickEdit(item: Modelo) {
    this._modeloservice.clearSessionStorageFatherModule();
    this._modeloservice.clearSessionStorage();
    this._modeloNavigationService.goToEdit(item.id);
  }

  clickDelete(item: Modelo) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._modelosApiService.onDelete(item.id, onDone);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/modelos/modelo-list/modelo-list.component.ts
 **/